import styled from "styled-components";
import backgroundImg from '../../assets/img/bg-img.jpg';

export const Container = styled.section`
    background: url(${backgroundImg}) no-repeat;
    background-position: center left;
    background-size: cover;
    width: 100%;
    height: auto;
    padding: 100px 20px 145px;
    box-shadow: 0 0 30px;

    color: #58626c;

    img.save {
        width: 22%;
        position: absolute;
    }

    div.timerContainer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;  
        height: 100%;  
    
        h1 {
            font-family: 'Great Vibes', sans-serif;
            font-size: 4rem;
            font-weight: 200;
        }
        h2 {
            font-family: 'Great Vibes', sans-serif;
            font-size: 2rem;
            font-weight: 200;
            margin-top: 30px;
            margin-bottom: -20px;
        }

        @media (max-width: 500px) {
            h1 {
                font-size: 3rem;
            }
        }
        div.countTimers {
            display: flex;
            align-items: center;
            border-radius: 20px;
            margin-top: 3rem;
            padding: 3rem;
            box-shadow: 0 0 25px -14px rgb(0 0 0 / 75%);
            color: #58626c;

            div.count {
                text-align: center;
                margin: 0 20px;  
                p.number {
                    font-size: 3rem;
                    font-family: 'Quicksand', sans-serif;
                }
                p.text {
                    margin-top: 10px;
                    font-size: 1.5rem;
                    font-family: 'Great Vibes', sans-serif;
                }
            }

            span {
                font-size: 3rem;
                font-family: 'Quicksand', sans-serif;
                margin-bottom: 45px;
            }       
        }

        @media (max-width: 530px) {
            div.countTimers {
                padding: 1rem;

                div.count {
                    p.number {
                        font-size: 2rem;
                    }
                    p.text {
                        font-size: 1rem;
                    }
                }

                span {
                    font-size: 2rem;
                    margin-bottom: 30px;
                }  
            }
        }  
        @media (max-width: 375px) {
            div.countTimers {
                display: flex;
                flex-direction: column;

                div.count {
                    margin: 10px 20px;

                    p.number {
                        font-size: 2rem;
                    }
                    p.text {
                        font-size: 1rem;
                    }
                }

                span {
                    display: none;
                }
            }
        }  
    }
    
    /* @media (max-width: 870px) {
        height: 80vh;
    } */
`